import { Provider } from '@angular/core';

import {
  CalendarA11y,
  CalendarDateFormatter,
  CalendarEventTitleFormatter,
  CalendarUtils,
  DateAdapter,
} from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { CustomDateFormatter } from './date-formatter.provider';

export const provideCalendar = (): Provider => [
  {
    provide: DateAdapter,
    useFactory: adapterFactory,
  },
  {
    provide: CalendarDateFormatter,
    useClass: CustomDateFormatter,
  },
  CalendarA11y,
  CalendarEventTitleFormatter,
  CalendarUtils,
];
